export default __webpack_public_path__ + "static/media/red_barn.41cd39c4.jpg";